var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreateManuallyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0072 1.76094C8.0469 2.0928 6.71955 2.93807 5.96279 4.36928C4.60692 6.93355 5.1837 8.81033 4.70955 10.7051C4.23539 12.5999 2.78169 13.2351 1.73613 14.7181C0.920027 15.8757 0.791112 18.6914 2.25363 20.0973C3.70053 21.4772 5.0348 22.7567 7.63259 22.3668C10.2043 21.9926 11.501 20.2593 14.2029 19.7185C16.9048 19.1777 19.1427 19.6729 20.5805 18.3896C22.0883 17.0439 23.6567 13.322 22.3095 10.6356C21.2259 8.47482 18.3128 8.34359 17.0274 6.31824C15.7421 4.29289 15.3495 3.14732 14.295 2.5542C12.8849 1.761 11.6091 1.48975 10.0072 1.76094Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59961 12.5555H14.3996M11.9552 10.2V15",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateManuallyIcon);
export default __webpack_public_path__ + "static/media/create-manually-icon.65c9e6d2168b864382d1ff1287711421.svg";
export { ForwardRef as ReactComponent };